import React from 'react';
import NegateIcon from '@material-ui/icons/ThumbDown';
import AffirmIcon from '@material-ui/icons/ThumbUp';
import FutureIcon from '@material-ui/icons/FlightTakeoff';
import IntIcon from '@material-ui/icons/HelpOutline';
import IntoIcon from '@material-ui/icons/ArrowForward';

/**
 * [negate] - thumb down - przeczące, negatywne
 * [affirm] - thumb up - pozytywne, twierdzące
 * [future] - plane
 * [int] - pytające
 * [into] - przekształcenie ->
 * [em][/em] - text na zielono
 * [ita][/ita] - tekst pochylony
 */

let em = false;
let italic = false;

const getPElement = (str, key) => {
  switch(str) {
    case 'em':
      em = true;
      return <React.Fragment key={key}></React.Fragment>
    case '/em':
      em = false;
      return <React.Fragment key={key}></React.Fragment>
    case 'ita':
      italic = true;
      return <React.Fragment key={key}></React.Fragment>
    case '/ita':
      italic = false;
      return <React.Fragment key={key}></React.Fragment>
    case 'negate':
      return <NegateIcon key={key} />
    case 'affirm':
      return <AffirmIcon key={key} />
    case 'future':
      return <FutureIcon key={key} />
    case 'int':
      return <IntIcon key={key} />
    case 'into':
      return <IntoIcon key={key} />
    default:
      if (em) {
        return <em key={key}>{str}</em>
      } else if (italic) {
        return <i key={key}>{str}</i>
      } else {
        return <React.Fragment key={key}>{str}</React.Fragment>
      }
  }
}

export const cleanArr = arr => {
  const arr1 = [];
  arr.forEach(el => {
    if (el.trim() !== '') arr1.push(el);
  })
  return arr1;
}

export const drawP = (p, idx) => {
  const arr = cleanArr(p.split(/\[|\]/));
  const key = 'p' + idx;
  em = false;

  return (
    <p key={key}>
      {arr.map((part, idx2) => getPElement(part, 's' + idx + '-' + idx2))}
    </p>
  );
}

export const clearStyling = () => {
  em = false;
  italic = false;
}